import React from "react";

const ParameterButtons = ({ selectParameter, parameters }) => {
  const buttons = [
    // { label: "Catégorie redevances", value: "categorie redevances" },
    { label: "Bureau", value: "bureau" },
    // { label: "Type de redevances", value: "type redevance" },
    { label: "Paramètre système", value: "systeme" },
  ];
  console.log("paramaters", parameters);

  return (
    <div className="flex flex-wrap space-x-4 lg:flex-nowrap justify-center mb-4">
      {(parameters ?? buttons).map((button) => (
        <div
          key={button.value}
          onClick={() => selectParameter(button.value)}
          className="bg-primary cursor-pointer hover:bg-blue-500 px-2 py-2 w-52 flex justify-center rounded-lg text-white font-semibold">
          <h2>{button.label}</h2>
        </div>
      ))}
    </div>
  );
};

export default ParameterButtons;
